

export function pause() {
    window.issieBridge.uart.pause();
}

export function continuedOp() {
    window.issieBridge.uart.continue();
}

export function connect(numberOfViewers) {
    return window.issieBridge.uart.connectAndRead(numberOfViewers);
}

export function simpleConnect() {
    return window.issieBridge.uart.simpleConnect();
}

export function disconnect() {
    window.issieBridge.uart.disconnect();
}

export function step() {
    window.issieBridge.uart.step();
}

export function readAllViewers(numberOfViewers) {
    return window.issieBridge.uart.readAllViewers(numberOfViewers);
}

export function stepAndReadAllViewers(numberOfViewers) {
    return window.issieBridge.uart.stepAndReadAllViewers(numberOfViewers);
}

